export const DETERMINATION_VOICE_MINUTES_BASE = 45;

function safeNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function normalizeVoicePlanId(planIdRaw) {
  const key = String(planIdRaw || '').trim().toLowerCase();
  if (!key) return 'free';
  if (key === 'pro' || key === 'determination' || key === 'family') return 'determination';
  if (
    key === 'plus'
    || key === 'engagement'
    || key === 'commitment'
    || key === 'lifetime'
    || key === 'student'
  ) {
    return 'commitment';
  }
  if (key === 'curiosity') return 'free';
  return key;
}

export function canAccessPremiumVoice(planIdRaw) {
  return normalizeVoicePlanId(planIdRaw) === 'determination';
}

export function getDefaultVoiceMinutesBase(planIdRaw) {
  return canAccessPremiumVoice(planIdRaw) ? DETERMINATION_VOICE_MINUTES_BASE : 0;
}

export function resolveVoiceMinutesBalanceForPlan({
  planId,
  voiceMinutesBase,
  voiceMinutesBonus,
  voiceMinutesUsed,
} = {}) {
  if (!canAccessPremiumVoice(planId)) {
    return {
      voiceMinutesBase: 0,
      voiceMinutesBonus: 0,
      voiceMinutesUsed: 0,
      remainingMinutes: 0,
    };
  }

  const resolvedBase = Math.max(0, safeNumber(voiceMinutesBase, getDefaultVoiceMinutesBase(planId)));
  const resolvedBonus = Math.max(0, safeNumber(voiceMinutesBonus, 0));
  const resolvedUsed = Math.max(0, safeNumber(voiceMinutesUsed, 0));

  return {
    voiceMinutesBase: resolvedBase,
    voiceMinutesBonus: resolvedBonus,
    voiceMinutesUsed: resolvedUsed,
    remainingMinutes: Math.max(0, Math.floor(resolvedBase + resolvedBonus - resolvedUsed)),
  };
}
